var map = {
	"./acrylic-print.svg": 50945,
	"./art-print.svg": 87915,
	"./art-product.svg": 61907,
	"./athletic-crop-top.svg": 93167,
	"./baby-leggings.svg": 45631,
	"./beanie.svg": 35726,
	"./bed-pillow-sham.svg": 9271,
	"./bed-pillow-sleeve.svg": 33540,
	"./big-square-scarf.svg": 14196,
	"./blanket.svg": 59459,
	"./bodycon-dress.svg": 80704,
	"./boxer-briefs.svg": 23022,
	"./boyshorts.svg": 36401,
	"./canvas.svg": 68350,
	"./capris.svg": 68384,
	"./cheeky-briefs.svg": 79741,
	"./classic-crewneck.svg": 45581,
	"./classic-pullover-hoodie.svg": 62401,
	"./coaster.svg": 62049,
	"./comfort-long-sleeve-t-shirt.svg": 69574,
	"./comfort-racerback-tank-top.svg": 44202,
	"./comfort-slimfit-t-shirt.svg": 19637,
	"./comfort-t-shirt.svg": 1466,
	"./crewneck-sweatshirt.svg": 19481,
	"./cropped-pullover-hoodie.svg": 70936,
	"./dad-cap.svg": 48974,
	"./day-tote.svg": 92571,
	"./desk-mat.svg": 16556,
	"./draped-kimono.svg": 46012,
	"./drawstring-bag.svg": 97505,
	"./duvet-cover.svg": 98750,
	"./fabric.svg": 13681,
	"./face-mask.svg": 8246,
	"./fitted-polo-shirt.svg": 71228,
	"./fitted-skirt.svg": 22744,
	"./fitted-tank-top.svg": 58189,
	"./flare-dress.svg": 80396,
	"./flare-skirt.svg": 36556,
	"./flow-pullover-hoodie.svg": 51849,
	"./flow-racerback-tank-top.svg": 53790,
	"./galaxy-s3.svg": 86997,
	"./galaxy-s4.svg": 93498,
	"./galaxy-s5.svg": 77271,
	"./galaxy-s6-edge.svg": 17653,
	"./galaxy-s6.svg": 90268,
	"./galaxy-s7-edge.svg": 53865,
	"./galaxy-s7.svg": 99809,
	"./galaxy-s8.svg": 87174,
	"./galaxy-s9.svg": 29171,
	"./headband.svg": 38513,
	"./holiday-stocking.svg": 57241,
	"./ipad-mini.svg": 56598,
	"./iphone4.svg": 1411,
	"./iphone5.svg": 57782,
	"./iphone6.svg": 86669,
	"./iphone6plus.svg": 21725,
	"./iphone7.svg": 36296,
	"./iphone7plus.svg": 51412,
	"./iphonex.svg": 16231,
	"./iphonexr.svg": 45367,
	"./iphonexsmax.svg": 16820,
	"./kangaroo-hoodie.svg": 85693,
	"./kimono-robe.svg": 73454,
	"./leggings.svg": 64758,
	"./lightweight-face-covering.svg": 49802,
	"./lightweight-face-covering@2x.svg": 54200,
	"./long-scarf.svg": 94544,
	"./loose-tank-top.svg": 56299,
	"./lounge-pants.svg": 12225,
	"./makeup-bag.svg": 52530,
	"./market-tote.svg": 67821,
	"./mini-shorts.svg": 31313,
	"./notebook.svg": 98457,
	"./origami-tote.svg": 75099,
	"./peignoir.svg": 56971,
	"./pencil-case.svg": 53126,
	"./permanent-sticker.svg": 9154,
	"./pillow18.svg": 26018,
	"./pillow20x14.svg": 52310,
	"./pillow22.svg": 71177,
	"./pillow24x12.svg": 30000,
	"./pillow26x20.svg": 78821,
	"./placemat.svg": 98827,
	"./poster.svg": 93581,
	"./premium-crewneck.svg": 89784,
	"./premium-long-sleeve-t-shirt.svg": 68149,
	"./premium-pullover-hoodie.svg": 60918,
	"./premium-t-shirt.svg": 82169,
	"./premium-unisex-tank-top.svg": 94079,
	"./premium-zipper-hoodie.svg": 26017,
	"./racerback-tank-top.svg": 80403,
	"./scoop-bralette.svg": 90808,
	"./shirt-bellacanvas-3001.svg": 60206,
	"./shirt-bellacanvas-6004.svg": 420,
	"./shirt-milltex-901.svg": 60711,
	"./shorts.svg": 32391,
	"./snapback.svg": 29979,
	"./spiral-notebook.svg": 28645,
	"./square-scarf.svg": 13143,
	"./stainless-steel-tumbler.svg": 58278,
	"./stainless-steel-water-bottle.svg": 22323,
	"./stationery-card.svg": 73319,
	"./tea-towel.svg": 17758,
	"./tote-bag.svg": 54253,
	"./unisex-joggers.svg": 68050,
	"./unisex-polo-shirt.svg": 46374,
	"./vegan-leather-backpack.svg": 94896,
	"./vegan-leather-crossbody-purse.svg": 91332,
	"./vegan-leather-makeup-bag.svg": 40222,
	"./vegan-leather-tote-bag.svg": 58545,
	"./wall-tapestry.svg": 54361,
	"./wood-print.svg": 18507,
	"./wrap-skirt.svg": 37084,
	"./yoga-capris.svg": 83013,
	"./yoga-leggings.svg": 59203,
	"./yoga-shorts.svg": 4390,
	"./youth-leggings.svg": 50068,
	"./zipper-carry-all.svg": 32844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24322;